<div class="modal-overlay">
	<div class="modal-box">
		<h2 class="modal-title">
			{{ 'old_version_flag.dialog_title' | translate }}
		</h2>
		<p class="modal-message">
			{{ 'old_version_flag.dialog_subtitle' | translate }}
		</p>
		<button class="modal-button" (click)="close()">Go Back</button>
	</div>
</div>
